import {
  ADMIN_INITIAL_STATE,
  FETCH_ADMIN_COMPANY_PROFILES_FOR_REVIEW,
  FETCH_ADMIN_EXPIRED_JOBS,
  FETCH_ADMIN_FREE_COMPANY_LOGOS_FOR_REVIEW,
  FETCH_ADMIN_FREE_JOBS_UNDER_REVIEW,
  FETCH_ADMIN_PAID_COMPANY_LOGOS_FOR_REVIEW,
  FETCH_ADMIN_PAID_JOBS_UNDER_REVIEW,
  FETCH_ADMIN_PROMOTIONAL_REQUESTS,
  FETCH_ADMIN_REQUESTED_DELETE_ACCOUNTS,
} from "./adminConstants";
import { SIGN_OUT_USER } from "../auth/authConstants";

export default function AdminReducer(
  state = ADMIN_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case FETCH_ADMIN_PAID_JOBS_UNDER_REVIEW:
      return {
        ...state,
        jobs: {
          ...state.jobs,
          underReview: payload,
        },
      };
    case FETCH_ADMIN_FREE_JOBS_UNDER_REVIEW:
      return {
        ...state,
        underReviewFreebies: {
          ...state.underReviewFreebies,
          jobs: payload,
        },
      };
    case FETCH_ADMIN_EXPIRED_JOBS:
      return {
        ...state,
        jobs: {
          ...state.jobs,
          expired: payload,
        },
      };
    case FETCH_ADMIN_PROMOTIONAL_REQUESTS:
      return {
        ...state,
        jobs: {
          ...state.jobs,
          promotionalRequests: payload,
        },
      };
    case FETCH_ADMIN_PAID_COMPANY_LOGOS_FOR_REVIEW:
      return {
        ...state,
        promotionServices: {
          ...state.promotionServices,
          featuredLogos: payload,
        },
      };
    case FETCH_ADMIN_FREE_COMPANY_LOGOS_FOR_REVIEW:
      return {
        ...state,
        underReviewFreebies: {
          ...state.underReviewFreebies,
          companyFeaturedLogos: payload,
        },
      };
    case FETCH_ADMIN_COMPANY_PROFILES_FOR_REVIEW:
      return {
        ...state,
        companyProfiles: {
          ...state.companyProfiles,
          underReview: payload,
        },
      };
    case FETCH_ADMIN_REQUESTED_DELETE_ACCOUNTS:
      return {
        ...state,
        accounts: {
          requestedDelete: payload,
        },
      };
    case SIGN_OUT_USER:
      return {
        ...state,
        ...ADMIN_INITIAL_STATE,
      };
    default:
      return state;
  }
}
